"use client";

import { useStore } from "zustand";

import { Toast } from "../Toast";
import { toastStore } from "./toastStore";

/**
 * トーストの表示コンテナ（右上に積む）。`notify(...)` で積まれた `toastStore` を購読する。
 * ページ（slide-studio）に1つ置く。自動消去はストア側（3.5s）。
 */
export function Toaster() {
    const toasts = useStore(toastStore, (s) => s.toasts);
    const dismiss = useStore(toastStore, (s) => s.dismiss);
    return (
        <div className="pointer-events-none fixed top-4 right-4 z-50 flex flex-col gap-2">
            {toasts.map((t) => (
                <div key={t.id} className="pointer-events-auto">
                    <Toast
                        message={t.message}
                        type={t.kind}
                        onClose={() => dismiss(t.id)}
                    />
                </div>
            ))}
        </div>
    );
}
